import { IGoofy } from 'interfaces/IGoofy';
import { apiService } from 'shared/services';
import { Observable } from 'rxjs/Observable';
import * as Sentry from '@sentry/browser';
import { ENABLE_GOOFY, IS_SHOPIFY } from '../settings';

export class GoofyService {
  public track(data: IGoofy) {
    if (!ENABLE_GOOFY || !data.trackerId) {
      console.log('GOOFY', data);
      return;
    }

    let url = '/goofy';
    if (IS_SHOPIFY) {
      url = '/a/sun/goofy';
    }

    apiService
      .post(url, data, null, {
        local: true
      })
      .retry(20)
      .catch(() => Observable.empty())
      .subscribe(() => {
        Sentry.addBreadcrumb({
          message: `Goofy: ${data.step}`,
          category: 'goofy',
          level: Sentry.Severity.Info,
          data: null
        });
      });
  }
}
// tslint:disable-next-line:variable-name
export const GoofyServiceFactory = () => new GoofyService();

export const goofyService = GoofyServiceFactory();

export default goofyService;
